module.exports = __webpack_public_path__ + "img/checked.cdcd8955.svg";